(function () {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc service
     * @memberOf ihh-utilities
     * @name FileUpload
     * @description This service uploads a file. Adapted from a service posted by Jenny Louthan posted at
     * {@link http://uncorkedstudios.com/blog/multipartformdata-file-upload-with-angularjs}. See the example below for how to use
     * the service in a controller.
     * @example
     * // Declaring the FileUpload service in a controller.
     * myModule.controller('MyCtrl', ['FileUpload', ..., function(FileUpload, ...) {
     *    ...
     * }
     */
    angular
        .module('ihh-common-web')
        .service('FileUpload', FileUpload);

    FileUpload.$inject = ['$http'];

    function FileUpload($http) {
        /**
         * Uploads a file using HTTP POST.
         * @ngdoc method
         * @name postFileToUrl
         * @memberOf ihh-utilities.FileUpload
         * @param {File} file the file object from an <code>&#060;input type="file"&#062;</code> HTML element.
         * @param {String} uploadUrl the URL to upload to
         * @param {String} formFieldName the form field name used to post the file
         * @param {Function} success a function that gets called on success
         * @param {Function} error a function that gets called on error
         */
        this.postFileToUrl = function(file, uploadUrl, formFieldName, success, error) {
            var fd = new FormData();
            fd.append(formFieldName, file);
            $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(success, error);
        };

        /**
         * Uploads a file using HTTP PUT.  See the examples below for how to use the directive on a page.
         * @ngdoc method
         * @name putFileToUrl
         * @memberOf ihh-utilities.FileUpload
         * @param {File} theFile the file object from an <code>&#060;input type="file" data-file-model="theFile"&#062;</code> HTML element.
         * @param {String} uploadUrl the URL to upload to
         * @param {Function} success a function that gets called on success
         * @param {Function} error a function that gets called on error
         * @param {String} contentType if set, overrides the content type from the file when uploading
         */
        this.putFileToUrl = function(theFile, uploadUrl, success, error, contentType) {
            $http.put(uploadUrl, theFile, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': contentType ? contentType : theFile.type
                }
            }).success(success).error(error);
        };
    }
})();